module.exports = __webpack_public_path__ + "img/Midi Hesston 1.2 x 0.9.8f9e17c8.jpg";